export const serviceAccountsUrl = () => "/settings/members#service-accounts";
export const serviceAccountDetailsUrl = ({ id }: { id: string }) => `/settings/members/service-account/${id}`;
